import { Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CompactTable } from "../../_components/table/compact.table";
import { getDate } from "../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { formService } from "../../_services/form.service";


export function UserProfileCurrentForm(params: { currentForm: FormTemplateTypeEnum }) {

    const { userId } = useParams<{ userId: string }>();
    let navigate = useNavigate();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(true);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 1, page: 0, order: 'desc', orderBy: '' });

    useEffect(() => {
        fetchData();
    }, [filter, params.currentForm]);


    function fetchData() {
        setLoading(true);
        return formService
            .getCurrent(params.currentForm, userId || '')
            .then(
                (json) => {
                    if (json) {
                        var _d = { count: 1, items: [json] };

                        setData(_d as any);
                    }
                    else {
                        setData({ items: [], count: 0 });
                    }
                }
            )
            .finally(() => setLoading(false));
    }

    function generateLicense(id: number) {
        navigate("" + id)
    }

    const _actions = accountService.isAdmin ? { onEdit: (d: any) => { navigate("" + d) } } : {};

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'status',
                header: 'Form Status',
            },
            {
                accessorKey: 'createdDate',
                header: 'Created Date',
                accessorFn: (rowData: any) => <>{getDate(rowData.createdDate)}</>
            },
            {
                accessorKey: 'userName',
                header: 'User Name',
            }
        ],
        [],
    );

    function createForm(type: FormTemplateTypeEnum) {

        return formService.createByType(type, userId)
            .then(
                data => {
                    navigate("../Forms/" + data)
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <PageHeader
                pageName="Licence Form"
                actionType={(!data || !data.items || !data.items.length) ? `create` : `edit`}
                buttonName={(!data || !data.items || !data.items.length) ? `New Application` : `Proceed To Application`}
                onClick={() => { (!data || !data.items || !data.items.length) ? (FormTemplateTypeEnum.CompetitionLicenceApplication == params.currentForm ? navigate("../CompetitionLicenceApplication") : createForm(params.currentForm)) : navigate(`../Forms/${(data.items[0] as any).id}`) }}
            />
            <Paper sx={{ marginBottom: "32px" }}>

                <CompactTable
                    columns={columns}
                    data={data.items}
                    enableTopToolbar={false}
                    isLoading={isLoading}
                    muiTableBodyRowProps={({ row }: { row: any }) => ({
                        onClick: () => {
                            navigate(`../Forms/${(data.items[0] as any).id}`)
                        },
                        sx: {
                            borderBottom: 'none',
                            borderTopStyle: 'none',
                            cursor: "pointer"
                        },
                    })}

                    enableRowActions={false}
                    muiTableContainerProps={{ sx: { maxHeight: '125px', height: "125px" } }}
                />


            </Paper>

        </>
    );
}